import React from 'react';
import { Group, Button, Title, Badge } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { DiagnosticReport } from '@medplum/fhirtypes';
import { StatusBadge } from '@/components/medplum-react/StatusBadge/StatusBadge';

// -----------------------------------------------------------------------------
interface DiagnosticReportHeaderProps {
  diagnosticReport: DiagnosticReport;
  orderId?: string;
  onNavigateBack: () => void;
  getConclusionDisplay: () => string;
  getConclusionColor: () => string;
}

// -----------------------------------------------------------------------------
export const DiagnosticReportHeader: React.FC<DiagnosticReportHeaderProps> = ({
  diagnosticReport,
  onNavigateBack,
  getConclusionDisplay,
  getConclusionColor,
}) => {
  // ---------------------------------------------------------------------------
  return (
    <Group justify="space-between">
      <Group>
        <Button
          variant="subtle"
          leftSection={<IconArrowLeft size={16} />}
          onClick={onNavigateBack}
        >
          Back to Order
        </Button>
        <Title order={1}>Diagnostic Report</Title>
      </Group>
      <Group>
        <StatusBadge
          status={diagnosticReport.status}
          size="lg"
        />
        <Badge color={getConclusionColor()} size="lg" variant="light">
          {getConclusionDisplay()}
        </Badge>
      </Group>
    </Group>
  );
};
